// extracted by mini-css-extract-plugin
module.exports = {"jenga-item":"jenga-item_jenga-item__IBNq2","title":"jenga-item_title__1_bK3","body":"jenga-item_body__39mOt"};